import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=97063284&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=97063284&prod&scoped=true&lang=css"
import style1 from "./Home.vue?vue&type=style&index=1&id=97063284&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97063284",
  null
  
)

export default component.exports